import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2, ShieldAlert } from "lucide-react";
import { LOGO_URL } from "../data/mock";

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash || window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    if (!sessionId) {
      setError("Sessione Google non trovata. Riprova il login.");
      setTimeout(() => navigate("/area-soci", { replace: true }), 2500);
      return;
    }

    axios
      .post(
        `${API}/api/auth/google-callback`,
        { session_id: sessionId },
        { withCredentials: true }
      )
      .then((r) => {
        sessionStorage.setItem("acdt_user", JSON.stringify(r.data));
        navigate(r.data.role === "admin" ? "/admin" : "/dashboard", { replace: true });
      })
      .catch((err) => {
        const msg = err.response?.data?.detail || "Errore durante il login con Google.";
        setError(msg);
        setTimeout(() => navigate("/area-soci", { replace: true }), 3000);
      });
  }, [location.hash, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#0a1f55] via-[#102a6b] to-[#1e3a8a] text-white p-6">
      <div className="text-center max-w-md">
        <img src={LOGO_URL} alt="A.C.D.T." className="h-16 w-16 mx-auto mb-6 bg-white rounded-2xl p-2" />
        {!error ? (
          <>
            <Loader2 className="h-10 w-10 animate-spin mx-auto mb-4 text-[#fbbf24]" />
            <h1 className="text-2xl font-extrabold">Accesso in corso…</h1>
            <p className="mt-2 text-slate-300 text-[14px]">Stiamo completando l&apos;autenticazione con Google.</p>
          </>
        ) : (
          <>
            <ShieldAlert className="h-12 w-12 mx-auto mb-4 text-red-300" />
            <h1 className="text-2xl font-extrabold">Login non riuscito</h1>
            <p data-testid="auth-callback-error" className="mt-2 text-slate-300 text-[14px]">{error}</p>
            <p className="mt-4 text-[12px] text-slate-400">Ritorno alla pagina di login…</p>
          </>
        )}
      </div>
    </div>
  );
}
